/**
 * @generated SignedSource<<12f60305def6ab4d33bb57e46cb6d9e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type task_CourseTitle_courseQuery$variables = {
  id: string;
};
export type task_CourseTitle_courseQuery$data = {
  readonly course: {
    readonly id: string;
    readonly title: string;
  };
};
export type task_CourseTitle_courseQuery = {
  response: task_CourseTitle_courseQuery$data;
  variables: task_CourseTitle_courseQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Course",
    "kind": "LinkedField",
    "name": "course",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "task_CourseTitle_courseQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "task_CourseTitle_courseQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2d024d283a6594ca9cc98c953da54acc",
    "id": null,
    "metadata": {},
    "name": "task_CourseTitle_courseQuery",
    "operationKind": "query",
    "text": "query task_CourseTitle_courseQuery(\n  $id: ID!\n) {\n  course(id: $id) {\n    id\n    title\n  }\n}\n"
  }
};
})();

(node as any).hash = "42f5a9fa7637a95b811913efef3efb98";

export default node;
